import React, { useState, useContext } from "react"
import {
  EmailContainer,
  EmailInput,
  EmailSubmitButton,
  EmailErrorText,
} from "./footer.email-submission.style"
import externalLinks from "../../external-links"

import { useForm } from "react-hook-form"
import useSiteMetadata from "./hooks/useSiteMetadata"
import { UIContext } from "./layout"

const HUBSPOT_ENDPOINT = externalLinks.hubspot.emailFooterSubmissionApi

export default function EmailSignup() {
  const { register, errors, handleSubmit } = useForm()
  const metadata = useSiteMetadata()
  const [hasSubmitted, setHasSubmitted] = useState(false)
  const [submissionFailure, setSubmissionFailure] = useState(false)
  const {
    state: { location },
  } = useContext(UIContext)

  const sumbitCallback = (data, e) => {
    e.preventDefault()

    const submissionData = Object.keys(data).reduce((acc, key) => {
      acc.push({
        name: key,
        value: data[key],
      })
      return acc
    }, [])

    const pageUri = metadata.siteURL + location.pathname

    const submission = {
      fields: [...submissionData],
      context: {
        pageUri,
        pageName: document.title,
      },
    }

    try {
      let hutk = document.cookie
        .split("; ")
        .find(row => row.startsWith("hubspotutk"))
        .split("=")[1]

      submission.context = {
        ...submission.context,
        hutk,
      }
    } catch (error) {}

    fetch(HUBSPOT_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submission),
    })
      .then(response => response.json())
      .then(data => {
        if (!data.errors) {
          setSubmissionFailure(false)
          setHasSubmitted(true)
        } else {
          setSubmissionFailure(true)
        }
      })
      .catch(error => {
        setSubmissionFailure(true)
      })
  }

  const error = submissionFailure
    ? "An error occured while submitting the form"
    : errors.email?.type === "pattern"
    ? "Enter a valid email address"
    : errors.email?.type === "required"
    ? errors.email.message
    : ""

  return (
    <EmailContainer onSubmit={handleSubmit(sumbitCallback)}>
      {error && <EmailErrorText>{error}</EmailErrorText>}
      <EmailInput
        name="email"
        aria-label="newsletter-signup"
        disabled={hasSubmitted}
        placeholder={"Your e-mail address"}
        ref={register({
          required: "This field is required (*)",
          //email regex from https://emailregex.com/
          //eslint-disable-next-line
          pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: "Enter a valid email address",
        })}
      ></EmailInput>
      <EmailSubmitButton type="submit" disabled={hasSubmitted}>
        {hasSubmitted ? "Subscribed" : "Sign Up"}
      </EmailSubmitButton>
    </EmailContainer>
  )
}
